export default __webpack_public_path__ + "static/media/vintage-typewriter-wooden-table(2)(1) (1).82939e2b.jpg";